<template>
  <div class="white ma-2 px-7 py-5 d-flex flex-column text-center rounded-lg">
    <div class="text-center" style="line-height: 1.2 !important">
      <h2 class="mb-3">Welcome back {{ pro.business_name }}!</h2>
      You've already claimed this account.  You don't need to set it up again.
      Click below to login and grow your business w/ Referra.
    </div>

    <div class="mt-4 primary--text" v-if="pro.lead_count > 0">
      <h2 v-if="pro.lead_count == 1">You have a lead waiting!</h2>
      <h2 v-else>You have {{ pro.lead_count }} leads waiting!</h2>
    </div>
    
    <div class="mt-6 mb-3 d-flex justify-center">
      <v-btn width="60%" type="submit" color="primary" :to="{ name: 'login' }">
        Take me to Login
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProInviteClaimed',

  props: ['pro'],
}
</script>